import React from "react";

import {
  Pill,
  QueueRow,
  QueueRowMeta,
  QueueRowSymbol,
  RowHeading,
  RowPills,
  ScrollingQueueList,
} from "../../styles";
import { formatAgeHours } from "../../utils/format";
import { JOB_STATE_TONES, JOB_STATUS_LABELS } from "../constants";
import { JobListProps } from "../types";
import {
  isPreHorizonBlocked,
  keyOfJob,
  rangeOfJob,
  subjectOfJob,
  titleOfJob,
} from "../utils/describeJob";

export const JobList: React.FC<JobListProps> = ({
  jobs,
  selectedKey,
  listRef,
  onSelect,
}) => {
  const rows = jobs.map((job) => {
    const key = keyOfJob(job);
    const description =
      job.kind === "snapshot"
        ? subjectOfJob(job)
        : `Price backfill · ${rangeOfJob(job)}`;
    return {
      key,
      title: titleOfJob(job),
      meta: `${description} · ${formatAgeHours(job.ageHours)}`,
      statusLabel: JOB_STATUS_LABELS[job.status],
      tone: JOB_STATE_TONES[job.state],
      isPreHorizon: isPreHorizonBlocked(job),
      isSelected: key === selectedKey,
      handleClick: () => onSelect(key),
    };
  });

  return (
    <ScrollingQueueList ref={listRef} aria-label="Background jobs">
      {rows.map(
        ({
          key,
          title,
          meta,
          statusLabel,
          tone,
          isPreHorizon,
          isSelected,
          handleClick,
        }) => (
          <li key={key}>
            <QueueRow
              type="button"
              $isSelected={isSelected}
              aria-pressed={isSelected}
              onClick={handleClick}
            >
              <RowHeading>
                <QueueRowSymbol>{title}</QueueRowSymbol>
                <RowPills>
                  <Pill $tone={tone}>{statusLabel}</Pill>
                  {isPreHorizon && <Pill $tone="unknown">Pre-horizon</Pill>}
                </RowPills>
              </RowHeading>
              <QueueRowMeta>{meta}</QueueRowMeta>
            </QueueRow>
          </li>
        ),
      )}
    </ScrollingQueueList>
  );
};
